import React from "react";

import JobForm from "./JobForm";

const JobsCreate = () => {
  return <JobForm isEditMode={false} />;
};

export default JobsCreate;
